module.exports = __webpack_public_path__ + "img/binding_width.0aca06a5.png";